import React from 'react';
import { Box, Grid2 as Grid, Link as MuiLink } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { postHasParent } from '../../../Utils/Post';
import { PostCategories, getCategoryForPostType, Groups } from '../../../Utils/Types';
import { postPath, dashboardPostPath, newPostPath } from '../../../Utils/routes';
import { menuItems } from '../../../Utils/Dashboard';
import useSpace from '../../../Hooks/useSpace';

function Breadcrumbs({ post = {}, isDashboard = false, isEdit, actions }: any) {
  const intl = useIntl();
  const { space } = useSpace();
  const isMessagingCategory = PostCategories.MESSAGING.includes(post.type);
  const parentPostCategory = getCategoryForPostType(post?.included?.source?.type);
  const postCategory = getCategoryForPostType(post.type);
  const isAdminOrFluimaster = Groups.ADMINS.includes(space.current_user_role);
  const postPathFn = isDashboard ? dashboardPostPath : postPath;

  let item;

  if (
    isDashboard ||
    (isAdminOrFluimaster && newPostPath(space.slug, post.type) === window.location.pathname)
  ) {
    const { path } =
      menuItems.find(({ key }) => key === (parentPostCategory || postCategory)) || menuItems[0];

    item = {
      name: intl.formatMessage({ id: `DASHBOARD.MENU.${parentPostCategory || postCategory}` }),
      href: `/${space.slug}/dashboard/${path}`,
    };
  } else {
    item = {
      name: space.name,
      href: `/${space.slug}`,
    };
  }

  if (isMessagingCategory) {
    if (post.authored_by) {
      item = {
        name: intl.formatMessage({ id: 'SPACE.CONTRIBUTIONS.MESSAGING.TITLE' }),
        href: `/${space.slug}/contributions/messaging`,
      };
    }
  }

  if (postHasParent(post)) {
    const { title, slug, type } = post?.included?.source || {};

    item = {
      name: title,
      href: postPathFn(space.slug, slug, type),
    };
  }

  if (isEdit && post.id) {
    item = {
      name: post.title,
      href: postPathFn(space.slug, post.slug, post.type),
    };
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
    >
      <Grid>
        <Box
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            display: 'block',
          }}
        >
          <MuiLink
            component={Link}
            to={item.href}
            data-testid="design-system-breadcrumb"
            underline="hover"
            color="inherit"
            sx={(theme: any) => ({
              fontWeight: theme.typography.fontWeightRegular,
            })}
          >
            <ChevronLeft
              sx={(theme: any) => ({
                color: 'inherit',
                marginBottom: theme.spacing(-0.8),
                marginRight: theme.spacing(1),
              })}
            />
            {item.name}
          </MuiLink>
        </Box>
      </Grid>

      {actions}
    </Grid>
  );
}

Breadcrumbs.propTypes = {
  post: PropTypes.object,
  isDashboard: PropTypes.bool,
  actions: PropTypes.node,
  isEdit: PropTypes.bool,
};

export default Breadcrumbs;
